export const OBJECT_SUBSCHEMA_SYMBOL = Symbol('initialSubschema');
export const FIELD_SUBSCHEMA_MAP_SYMBOL = Symbol('subschemaMap');
//# sourceMappingURL=symbols.js.map